import GooglePlaces from "../Models/GooglePlaces";
import { API_BASE_URL } from "../Common/Common";
import GoogleSearch from "../Models/GoogleSearch";
import WikiMedia from "../Models/Wikimedia";
import Flickr from "../Models/Flickr";
import { searchRadiusKm } from "../Common/placeSize";
import Place from "../Models/Place";
import { getFeaturedPlaceMatch } from "../Common/FeaturedPlaceImages";
class PlaceMenu {
  static handleCenterInMap(id) {}

  static handleShowStreetView(id) {
    const place = window.guide_obj.places.getPlace(id);
    if (place == null) return null;
    let action = `http://maps.google.com/maps?q=&layer=c&cbll=${place.Lat},${place.Longi}&cbp=11,0,0,0,0`;
    let htmlString = `<!DOCTYPE html>
<html>
  <head>
    <title>StreetView</title>
    <meta http-equiv='Content-Type' content='text/html; charset=utf-8'/>
  </head>
  <body>
    <script type='text/javascript'>
      window.location.href = "${action}";
    </script>
  </body>
</html>`;
    let win = window.open("about:blank", "", "_blank");
    if (win == null) return;
    win.document.write(htmlString);
    win.focus();
  }

  static handleWeatherForecast(id) {
    const place = window.guide_obj.places.getPlace(id);
    if (place == null) return null;
    const _url = `https://www.wunderground.com/forecast/${place.Lat},${place.Longi}`;
    let win = window.open(_url, "_blank");
    if (win == null) return;
    win.focus();
  }

  static handleShowInGoogleMaps(id) {
    const place = window.guide_obj.places.getPlace(id);
    if (place == null) return null;
    let query;
    if (place.Name) {
      const parts = [place.Name, place.City, place.Country].filter(Boolean);
      query = encodeURIComponent(parts.join(", "));
    } else {
      query = `${place.Lat},${place.Longi}`;
    }
    window.open(`https://www.google.com/maps/search/?api=1&query=${query}`, "_blank");
  }

  static handleShowPlaceAttributes(id, SearchResultsPlacesList) {
    let place = window.guide_obj.places.getPlace(id);
    if (place == null && SearchResultsPlacesList !== null) {
      const index = SearchResultsPlacesList.findIndex((x) => x.ID === id);
      if (index !== -1) place = SearchResultsPlacesList[index];
    }
    if (place == null) return "";
    //console.log(place);
    try {
      let htmlString = place.createPlaceDetailsHTML(place.Info, null, window.guide_obj, place.scheduledDates);
      return htmlString;
    } catch (e) {
      return "";
    }
  }

  static handleShowPlaceUrl = (id) => {
    const place = window.guide_obj.places.getPlace(id);
    if (place == null) return "";
    let link = place.getFirstHLink();
    if (!link) return;
    if (link.includes("place_id=")) {
      const parts = link.split("=");
      console.log("parts", parts);
      GooglePlaces.getMoreDetails(this.getMoreDetailsCallback, parts[1]);
      return;
    }
    if (link !== "") {
      let win = window.open(link, "_blank");
      if (win == null) return null;
      win.focus();
      return null;
    }
  };

  static getMoreDetailsCallback = (place_id, details) => {
    if (details === null) return;
    let hlink = "";
    console.log("getMoreDetailsCallback", details);
    if (typeof details.url != "undefined") {
      if (details.url.includes(";")) {
        const urls = details.url.split(";");
        hlink = `${urls[0]}`;
      } else hlink = `${details.url}`;
    }
    console.log("getMoreDetailsCallback", hlink);
    if (hlink !== "") {
      let win = window.open(hlink, "_blank");
      if (win == null) return null;
      win.focus();
      return null;
    }
  };

  static handleGoToYelp(id) {
    const place = window.guide_obj.places.getPlace(id);
    if (place == null) return "";
    let action = `https://www.yelp.com/search?find_loc=${place.Lat},${place.Longi}`;
    let htmlString = `<!DOCTYPE html>
<html>
  <head>
    <title>StreetView</title>
    <meta http-equiv='Content-Type' content='text/html; charset=utf-8'/>
  </head>
  <body>
    <script type='text/javascript'>
      window.location.href = "${action}";
    </script>
  </body>
</html>`;
    let win = window.open("about:blank", "", "_blank");
    if (win == null) return;
    win.document.write(htmlString);
    win.focus();
  }

  static handleGoToFoursquare(id) {
    const place = window.guide_obj.places.getPlace(id);
    if (place == null) return "";
    let action = `https://foursquare.com/explore?mode=url&ll=${place.Lat},${place.Longi}&q=Top%20Picks`;

    let htmlString = `<!DOCTYPE html>
<html>
  <head>
    <title>StreetView</title>
    <meta http-equiv='Content-Type' content='text/html; charset=utf-8'/>
  </head>
  <body>
    <script type='text/javascript'>
      window.location.href = "${action}";
    </script>
  </body>
</html>`;
    let win = window.open("about:blank", "", "_blank");
    if (win == null) return;
    win.document.write(htmlString);
    win.focus();
  }

  static handleSetAsCurrentLocation(id) {
    const place = window.guide_obj.places.getPlace(id);
    if (place == null) return;
    const location = { latitude: parseFloat(place.Lat), longitude: parseFloat(place.Longi) };
    return location;
  }

  static handleEditPlace() {}

  static buildPhotoSearchQuery(place) {
    let query = place.Name;
    if (place.City && place.City !== "") {
      query += " " + place.City;
    } else if (place.Country && place.Country !== "") {
      query += " " + place.Country;
    } else {
      const catName = window.guide_obj.categoryNamesFromIDs
        ? window.guide_obj.categoryNamesFromIDs(place.Category, " ")
        : "";
      if (catName) query += " " + catName;
    }
    if (place.Country && place.Country !== "" && place.City && place.City !== "")
      query += " " + place.Country;
    return query;
  }

  static searchPlacePhotoGoogle(query, callback, placeId) {
    const q = query.replace(/ /g, "%20");
    const url =
      `https://www.googleapis.com/customsearch/v1?key=${process.env.REACT_APP_GOOGLE_CUSTOM_SEARCH_KEY}` +
      `&searchType=image&cx=${process.env.REACT_APP_GOOGLE_SEARCH_CX}&imgSize=XLARGE&fileType=jpg&imgType=photo&q=${q}&start=1`;
    // Plain fetch() with no timeout meant a single hung response left this
    // place's callback never firing at all, stalling any bulk enrichment
    // pass (Build My Trip's enrichPlacePhoto, "Auto Set Photo") on that one
    // place indefinitely. Matches GoogleSearch.js's identical fix — see its
    // comment (real report: TripAI's own photo chain stuck at 3/31).
    // Found/prioritized 2026-09-05.
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 10000);
    fetch(url, { signal: controller.signal })
      .then((r) => r.json())
      .then((data) => {
        clearTimeout(timeoutId);
        callback(GoogleSearch.processImages(data), placeId);
      })
      .catch(() => {
        clearTimeout(timeoutId);
        callback([], placeId);
      });
  }

  // static.flickr.com sends no CORS headers and serves http:// only (mixed
  // content on this https page) — route through the same proxy
  // ExportVideoModal/PlacesHeader use, which serves https and adds
  // Access-Control-Allow-Origin: *.
  static FLICKR_IMG_PROXY = `${API_BASE_URL}/img_proxy.php?url=`;

  // Flickr fallback for autoSetPhoto — bare place.Name (not the City/Country-
  // augmented buildPhotoSearchQuery used for Google/Wikimedia above): Flickr
  // is already geo-constrained to a radius around the place's coordinates
  // when available, so also requiring the text to match City/Country tends
  // to over-narrow results to nothing.
  // licenses: optional comma-separated Flickr license ids (default: all).
  static searchPhotoFlickr(place, callback, licenses) {
    const hasCoords =
      typeof place.Lat === "number" && !isNaN(place.Lat) &&
      typeof place.Longi === "number" && !isNaN(place.Longi) &&
      !(place.Lat === 0 && place.Longi === 0);
    const _Flickr = new Flickr();
    const onResult = (photos) => {
      if (!photos || photos.length === 0) { callback([]); return; }
      const results = photos
        .filter((p) => typeof p.title !== "undefined")
        .map((p) => {
          const base = `http://farm${p.farm}.static.flickr.com/${p.server}/${p.id}_${p.secret}`;
          // "_z" (640px) is reliably generated for every photo, unlike
          // larger sizes which only exist for sufficiently high-res originals.
          const url = PlaceMenu.FLICKR_IMG_PROXY + encodeURIComponent(`${base}_z.jpg`);
          return { url, url_m: url };
        });
      callback(results);
    };
    if (hasCoords) {
      _Flickr.searchPhotos("", place.Name, "20", onResult, {
        center: { latitude: place.Lat, longitude: place.Longi },
        radius: 32, // Flickr's documented max radius (km)
      }, licenses);
    } else {
      _Flickr.searchPhotos(undefined, place.Name, "20", onResult, undefined, licenses);
    }
  }

  // Sets place.Photo/Photo_m — live Wikimedia Commons search first (free,
  // and directly matched to this specific place by name/city/country, so
  // much less likely to be wrong than a pre-scraped match), then the
  // Featured-Guides manifest (also free, but its Wikipedia photos were
  // scraped and fuzzy-matched offline, which occasionally picks an
  // unrepresentative image — demoted to a fallback rather than tried
  // first), then Google Custom Search (the only one billed per view), then
  // Flickr as the last resort. Reordered 2026-08-29 — see memory:
  // project_cost_revenue_viability. Calls callback(success) when done.
  //
  // Custom Search's `url_m` (GoogleSearch.processImages' `photo.link`) is the
  // ORIGINAL third-party site's own hosted image — not Google-hosted at all
  // — so it inherits that site's own reliability: some are HTTP-only (mixed-
  // content blocked on this HTTPS app) or hotlink-block direct <img> access
  // entirely. Routed through Place.proxyImageUrl (a no-op for the reliable
  // hosts — Places/Wikimedia/gstatic — and Flickr results are already
  // pre-proxied by searchPhotoFlickr) so a broken third-party host doesn't
  // become a permanently-broken photo baked into the guide/itinerary.
  // allowPaidFallback=false stops after the two free sources (Wikimedia
  // Commons, then the FeaturedPlaceImages manifest) and skips
  // _autoSetPhotoFromSearch entirely — that covers both Google Custom
  // Search Images (billed, ~100 free queries/day then billed per 1,000 —
  // see project_cost_revenue_viability memory) and its Flickr fallback, so
  // this trades away free Flickr results too for simplicity/parity with
  // mobile's enrichPlacePhoto. Used for high-frequency, unbounded add paths
  // (e.g. "Add POI to Guide") where the wizard flows' one-shot paid
  // fallback isn't worth the exposure; those flows keep the default (true).
  // "No good photo found" memory — kept only in this browser (localStorage),
  // per guide, so bulk photo refreshes don't keep retrying (and spending the
  // small HasData quota on) places where nothing suitable exists. Set when a
  // search finds nothing or when the user clears a photo; cleared when a
  // photo is successfully set. An explicit single-place "Auto Update Photo"
  // ignores it and retries anyway.
  static _noPhotoStoreKey = "andiamo_no_good_photo_v1";
  static _readNoPhotoStore() {
    try { return JSON.parse(localStorage.getItem(PlaceMenu._noPhotoStoreKey) || "{}") || {}; } catch (e) { return {}; }
  }
  static _writeNoPhotoStore(store) {
    try { localStorage.setItem(PlaceMenu._noPhotoStoreKey, JSON.stringify(store)); } catch (e) { /* storage unavailable */ }
  }
  static hasNoGoodPhoto(place) {
    const gid = window.guide_obj?.guide_id;
    if (!place || gid == null) return false;
    return (PlaceMenu._readNoPhotoStore()[gid] || []).includes(place.ID);
  }
  static setNoGoodPhoto(place, flagged) {
    const gid = window.guide_obj?.guide_id;
    if (!place || gid == null) return;
    const store = PlaceMenu._readNoPhotoStore();
    const ids = new Set(store[gid] || []);
    if (flagged) ids.add(place.ID); else ids.delete(place.ID);
    if (ids.size > 0) store[gid] = Array.from(ids); else delete store[gid];
    PlaceMenu._writeNoPhotoStore(store);
  }

  // Reset a place to the default illustrated image (an empty Photo renders as
  // that default everywhere via Common.getImageURL) and remember not to
  // auto-search it again in bulk refreshes.
  static clearPhoto(place) {
    if (!place) return;
    place.Photo = "";
    place.Photo_m = "";
    PlaceMenu.setNoGoodPhoto(place, true);
  }

  static autoSetPhoto(place, callback, options) {
    PlaceMenu._autoSetPhotoSearch(place, (found) => {
      if (place) PlaceMenu.setNoGoodPhoto(place, found !== true);
      if (callback) callback(found);
    }, options);
  }

  static _autoSetPhotoSearch(place, callback, { allowPaidFallback = true, licenseSafe = false } = {}) {
    if (place == null) {
      if (callback) callback(false);
      return;
    }
    if (licenseSafe) {
      PlaceMenu._autoSetPhotoLicenseSafe(place, callback);
      return;
    }
    const query = PlaceMenu.buildPhotoSearchQuery(place);
    // Tried FIRST, ahead of even the free Wikimedia/FeaturedPlaceImages
    // steps below — user's explicit choice, prioritizing the real
    // business-listing photo (a genuine quality win over every other source
    // here, including Wikimedia) over saving a free call on places
    // Wikimedia could've covered for $0. See
    // src/dataBase/api-dev/hasdata_places_photo.php's comment for the full
    // story (2026-09-05) — it's an unofficial Google Maps scraper, same
    // ToS/reliability caveat as everywhere else a scraper is used in this
    // app.
    //
    // Which paid source is tried now follows PLACES_PROVIDER (added
    // 2026-09-24) instead of always calling HasData regardless of that
    // setting — the gap that left this silently degraded to the free chain
    // during HasData's 2026-09-24 credit exhaustion, even though OpenWeb
    // Ninja was already the live default for place search/hours elsewhere.
    // Still exactly one paid call per place, same budget as before — just
    // choosing which vendor makes it.
    if (allowPaidFallback) {
      const paidSource = GooglePlaces.getPhotoProviderChain();
      paidSource.searchPlacePhoto(query, (photo) => {
        if (photo) {
          place.Photo = photo;
          place.Photo_m = photo;
          if (callback) callback(true);
          return;
        }
        PlaceMenu._autoSetPhotoFallbackChain(place, query, callback, allowPaidFallback);
      }, place.Lat, place.Longi);
      return;
    }
    PlaceMenu._autoSetPhotoFallbackChain(place, query, callback, allowPaidFallback);
  }

  static _categoryNames(place) {
    try {
      return window.guide_obj.categoryNamesFromIDs(place.Category, " ") || "";
    } catch (e) {
      return "";
    }
  }

  // "Auto Update Photo" / "Refresh Photos": only images with no usage
  // conditions (public domain / CC0 / "no restrictions"), so nothing has to
  // be credited. Sources, in order: Wikimedia Commons (text + near the
  // place, unrestricted licenses only), the Featured-Guides list (the app's
  // own curated photos), then Flickr near the place (unrestricted licenses
  // only). HasData listing photos and Google Custom Search are NOT used —
  // neither reports a license. Falls back to no photo (the caller then keeps
  // or clears it) when nothing qualifies.
  static _autoSetPhotoLicenseSafe(place, callback) {
    const query = PlaceMenu.buildPhotoSearchQuery(place);
    WikiMedia.searchImagesForPlace(query, place.Lat, place.Longi, (wikiList) => {
      if (wikiList.length > 0) {
        place.Photo = Place.proxyImageUrl(wikiList[0].url);
        place.Photo_m = Place.proxyImageUrl(wikiList[0].url_m);
        if (callback) callback(true);
        return;
      }
      getFeaturedPlaceMatch(place.Country, place.City, place.Name).then((match) => {
        if (match) {
          place.Photo = match.photo || match.photo_m;
          place.Photo_m = match.photo_m || match.photo;
          if (!place.Info && match.info) place.Info = match.info;
          if (callback) callback(true);
          return;
        }
        PlaceMenu.searchPhotoFlickr(place, (flickrList) => {
          if (flickrList.length > 0) {
            place.Photo = flickrList[0].url;
            place.Photo_m = flickrList[0].url_m;
            if (callback) callback(true);
          } else if (callback) callback(false);
        }, Flickr.UNRESTRICTED_LICENSES);
      });
    }, place.ID, {
      unrestrictedOnly: true,
      matchName: place.Name,
      // wider for mountains, lakes, parks... (photos are taken from far away)
      radiusKm: searchRadiusKm(place.Name, PlaceMenu._categoryNames(place)),
    });
  }

  static _autoSetPhotoFallbackChain(place, query, callback, allowPaidFallback) {
    // Text AND files near the place (best matches first); text only when the
    // place has no coordinates. The nearby half needs the updated
    // wikimedia_get_images.php proxy — until it's deployed this is the same
    // as the text-only search.
    WikiMedia.searchImagesForPlace(query, place.Lat, place.Longi, (wikiList) => {
      if (wikiList.length > 0) {
        place.Photo = Place.proxyImageUrl(wikiList[0].url);
        place.Photo_m = Place.proxyImageUrl(wikiList[0].url_m);
        if (callback) callback(true);
        return;
      }
      getFeaturedPlaceMatch(place.Country, place.City, place.Name).then((match) => {
        if (match) {
          place.Photo = match.photo || match.photo_m;
          place.Photo_m = match.photo_m || match.photo;
          if (!place.Info && match.info) place.Info = match.info;
          if (callback) callback(true);
          return;
        }
        if (!allowPaidFallback) {
          if (callback) callback(false);
          return;
        }
        PlaceMenu._autoSetPhotoFromSearch(place, callback);
      });
    }, place.ID);
  }

  static _autoSetPhotoFromSearch(place, callback) {
    const query = PlaceMenu.buildPhotoSearchQuery(place);
    PlaceMenu.searchPlacePhotoGoogle(query, (imageList) => {
      if (imageList.length > 0) {
        place.Photo = Place.proxyImageUrl(imageList[0].url);
        place.Photo_m = Place.proxyImageUrl(imageList[0].url_m);
        if (callback) callback(true);
      } else {
        PlaceMenu.searchPhotoFlickr(place, (flickrList) => {
          if (flickrList.length > 0) {
            place.Photo = flickrList[0].url;
            place.Photo_m = flickrList[0].url_m;
            if (callback) callback(true);
          } else {
            if (callback) callback(false);
          }
        });
      }
    }, place.ID);
  }
}
export default PlaceMenu;
